import SubstackChange1 from 'src/components/subStackChange';
import SubstackSolo1 from 'src/components/subStackSolo';
import * as React from 'react';
export default {
  SubstackChange1,
  SubstackSolo1,
  React
};